import Moment from 'moment';

export function format(formatType, value) {
    if (value) {
      switch (formatType) {
        case "date":
          return Moment(value).format('DD-MM-YYYY');
  
        case "dateTime":
          return Moment(value).format('DD-MM-YYYY HH:mm');
        case "time":
          return Moment(value).format('LT');
        case "number":
          return value ? value.toFixed(2) : 0.00;
        default:
          return value;
      }
    }
    else
      return '-'
  }